import { ICarePlanHospitalizationsStore } from './types';

const initStore: ICarePlanHospitalizationsStore = {
  items: [],
};

export default initStore;
